import { render, staticRenderFns } from "./ResourceNotFoundCmp.vue?vue&type=template&id=0600c4ca&scoped=true&"
import script from "./ResourceNotFoundCmp.vue?vue&type=script&lang=js&"
export * from "./ResourceNotFoundCmp.vue?vue&type=script&lang=js&"
import style0 from "./ResourceNotFoundCmp.vue?vue&type=style&index=0&id=0600c4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0600c4ca",
  null
  
)

export default component.exports